import { Action } from 'redux';
// import { Customer } from 'src/types/model';

export interface LabelState {
  loading: boolean;
  //   data: Customer[];
  data: any;
  error: string | null;
}

export const FETCH_LABEL_REQUEST = 'FETCH_LABEL_REQUEST';
export const FETCH_LABEL_SUCCESS = 'FETCH_LABEL_SUCCESS';
export const FETCH_LABEL_FAILURE = 'FETCH_LABEL_FAILURE';

export interface FetchLabelRequestAction
  extends Action<typeof FETCH_LABEL_REQUEST> {}

export interface FetchLabelSuccessAction
  extends Action<typeof FETCH_LABEL_SUCCESS> {
  payload: any[];
}

export interface FetchLabelFailureAction
  extends Action<typeof FETCH_LABEL_FAILURE> {
  payload: string;
}

export type LabelActionType =
  | FetchLabelRequestAction
  | FetchLabelSuccessAction
  | FetchLabelFailureAction;
